import { Skeleton } from '@/core/tamagoshi/Skeleton/Skeleton';

import styles from './NbProductsSkeleton.module.scss';

export const NbProductsSkeleton = () => <Skeleton className={styles.root} />;
